var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.004 9.454c.168 0 .337.064.466.192l1.321 1.315a.661.661 0 0 1 .141.207l.001.002.001.002v.001l.001.002h.001a.666.666 0 0 1-.028.567l-.001.002v.002l-.002.002v.002c-.002 0-.002.002-.002.002l-.001.001v.002H5.9v.003h-.002v.002l-.002.002v.002l-.002.002v.001a.691.691 0 0 1-.092.121s0 .002-.002.002l-.001.002h-.002l-.001.002s-.001-.001-.001.002h-.002l-.002.002-1.321 1.315a.66.66 0 1 1-.932-.936l.186-.186h-1.67a.66.66 0 1 1 0-1.322h1.67l-.186-.185a.66.66 0 0 1 .466-1.13zM6.208 1.594c-1.722 0-3.118 1.417-3.118 3.163 0 1.747 1.396 3.163 3.118 3.163s3.118-1.416 3.118-3.163c0-1.746-1.396-3.163-3.118-3.163z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.999 9.091h2.406c1.77 0 3.269 1.337 3.269 2.916 0 .294 0 .645-.062.942l-.009.06c-.02.11-.15.213-.338.213h-3.8a.52.52 0 0 1-.48-.285l-1.47-3.218c-.137-.3.115-.628.484-.628z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.bcc9b0a24dd8a9dcc1d482a6909fa7be.svg";
export { ForwardRef as ReactComponent };